import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoginToken } from "../../../../utils/storageUtils";
import {
  convertToEasternISO,
  getDateDaysAgo,
  toUTCDateString,
} from "../../../../utils/dateFormatter";
import { getUserStatsStart } from "../../../../store/redux-slices/dashboard";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import { getFileRequest } from '../../../../utils/axios'
import { toast } from '../../../../components/Toast'





const useUserStats = () => {
  const dispatch = useDispatch();
  const { userStatsLoading: loading, UserStats } = useSelector(
    (state) => state.dashboard
  );
  const [selectedTab, setSelectedTab] = useState("casino");
  const [filter, setSelectedFilter] = useState("today");
  const filters = [
    [
      { label: "TODAY", key: "today" },
      { label: "YESTERDAY", key: "yesterday" },
      { label: "THIS WEEK", key: "this_week" },
      { label: "THIS MONTH", key: "this_month" },
      { label: "CUSTOM", key: "custom" },
    ],
  ];

  const [search, setSearch] = useState("");
  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(0),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const isInitialRender = useDidMountEffect();
  const totalPages = Math.ceil(UserStats?.pagination?.totalPages);

  const loadUserStats = (data) => {
    const startDate = convertToEasternISO(
      data?.action === "refresh"
        ? getDateDaysAgo(0)
        : state.map((a) => a.startDate)
    );
    const endDate = convertToEasternISO(
      data?.action === "refresh" ? new Date() : state.map((a) => a.endDate)
    );
    const searchString = data?.action === "refresh" ? "" : search;
    const selectedFilter = data?.action === "refresh" ? "today" : filter;

    dispatch(
      getUserStatsStart({
        startDate,
        endDate,
        filter: selectedFilter,
        page,
        limit,
        search: searchString,
      })
    );
  };

  useEffect(() => {
    if (!isInitialRender) loadUserStats();
  }, [page]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadUserStats();
    }, 800);
    return () => clearTimeout(delayDebounceFn);
  }, [filter, state, search, limit]);

  // useEffect(() => {
  //   loadUserStats();
  // }, [filter, state, search]);

  // const getCsvDownloadUrl = () =>
  //   `${process.env.REACT_APP_API_URL
  //   }/api/admin/user/user-stats?csvDownload=true&token=${getLoginToken()}`;



  // const getCsvDownloadUrl = () => {
  //   console.log(state, "statestate")
  //   const query = {
  //     csvDownload: true,
  //     token: getLoginToken(),
  //     startDate: state?.[0]?.startDate,
  //     endDate: state?.[0]?.endDate,
  //     filter: filter,

  //     search: search
  //   };

  //   const params = new URLSearchParams();

  //   Object.entries(query).forEach(([key, value]) => {
  //     if (value !== undefined && value !== null && value !== "") {
  //       params.append(key, value);
  //     }
  //   });

  //   return `${process.env.REACT_APP_API_URL}/api/admin/user/user-stats?${params.toString()}`;
  // };

  const getCsvDownloadUrl = () => {
    const startDate = state?.[0]?.startDate;
    const endDate = state?.[0]?.endDate;
    const selectedFilter = filter;
    const searchString = search;
    const query = {
      csvDownload: true,
      token: getLoginToken(),
      startDate: startDate ? new Date(startDate).toISOString() : undefined,
      endDate: endDate ? new Date(endDate).toISOString() : undefined,
      filter: selectedFilter,
     
      search: searchString
    };
  
    const params = new URLSearchParams();
  
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });
  
    return `${process.env.REACT_APP_API_URL}/api/admin/user/user-stats?${params.toString()}`;
  };
  




  const handleDownload = async () => {
    try {
      const response = await getFileRequest(getCsvDownloadUrl());
      const result = response?.data?.data?.result;

      if (result?.csv && result?.csvData) {
        const blob = new Blob([result.csvData], { type: 'text/csv;charset=utf-8;' });
        const downloadUrl = URL.createObjectURL(blob);

        const element = document.createElement('a');
        element.href = downloadUrl;
        element.download = result.fileName || `report_${Date.now()}.csv`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        URL.revokeObjectURL(downloadUrl);
        toast('CSV downloaded successfully', 'success');
      } else {
        toast('No CSV data found', 'error');
      }
    } catch (error) {
      console.error('Download error:', error);
      toast('Error downloading CSV', 'error');
    }
  };


  const handleResetFilters = useCallback(() => {
    setSearch("");
    setSelectedFilter("today");
    setState([{
      startDate: getDateDaysAgo(0),
      endDate: new Date(),
      key: "selection",
    }]);

    // loadUserStats({ action: "refresh" });
  }, []);

  return {
    loadUserStats,
    loading,
    setState,
    state,
    getCsvDownloadUrl,
    selectedTab,
    setSelectedTab,
    search,
    setSearch,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    filters,
    filter,
    setSelectedFilter,
    UserStats,
    handleResetFilters,
    handleDownload
  };
};

export default useUserStats;
